<ion-app>
  <ion-router-outlet (activate)="onPageActivated()"></ion-router-outlet>
</ion-app>
